import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  Paragraph,
  IconSVG,
} from 'components';

const WhatWeUse = () => (
  <Section color={'white'}>
    <SectionHeader
      size={'big'}
      lineColor={'pigeon-post'}
      headingType={2}
      description={
        'Our skilled AI engineers have competences in following areas:'
      }
    >
      What we use
    </SectionHeader>
    <Row className={'no-gap anim-fade-in-bottom machine-learning__wwu-list'}>
      <Col sm={12} md={4} className={'machine-learning__wwu-item'}>
        <IconSVG name={'eye'} size={'large'} color={'black'} />
        <Heading size={'medium-plus'} type={3}>
          Machine learning models
        </Heading>
        <Paragraph additionalClass={'text--light'}>
          Machine learning models and algorithms can recognize patterns in big
          data sets, cluster information, and make predictions based on their
          findings.
        </Paragraph>
      </Col>
      <Col sm={12} md={4} className={'machine-learning__wwu-item'}>
        <IconSVG name={'network'} size={'large'} color={'black'} />
        <Heading size={'medium-plus'} type={3}>
          Deep neural networks
        </Heading>
        <Paragraph additionalClass={'text--light'}>
          Deep learning can be applied to a variety of problems such as
          computer vision and speech recognition.
        </Paragraph>
      </Col>
      <Col sm={12} md={4} className={'machine-learning__wwu-item'}>
        <IconSVG name={'brain'} size={'large'} color={'black'} />
        <Heading size={'medium-plus'} type={3}>
          Ready-made SaaS solutions
        </Heading>
        <Paragraph additionalClass={'text--light'}>
          Microsoft Azure, Google Cloud, IBM Cloud and Amazon Web Services
          offer off-the shelf models to deliver an initial solution as soon as
          possible so you can test your idea within a reasonable budget.
        </Paragraph>
      </Col>
    </Row>
  </Section>
);

export default WhatWeUse;
